import React, { useEffect, useState } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { cameraService } from '../../services/central-api/cameras';

interface Props {
    value: string;
    setValue: React.Dispatch<React.SetStateAction<string>>;
    integrationType: 'type_2' | 'type_3' | 'all';
    zIndex: number;
}

export default function CamerasThirdPartyOriginDropdown({ value, setValue, integrationType, zIndex }: Props) {
    const [selectableThirdPartyOrigin, setSelectableAThirdPartyOrigin] = useState<{ label: string; value: string; }[]>([]);

    async function getThirdPartyOrigins({ integrationType }: { integrationType: 'type_2' | 'type_3' | 'all'; }) {
        try {
            const origins = await cameraService.getThirdPartyCameraOrigins(integrationType);

            setSelectableAThirdPartyOrigin([
                ...origins.map((origin) => {
                    return {
                        value: origin.origin,
                        label: origin.origin
                    };
                })
            ]);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getThirdPartyOrigins({ integrationType });
    }, [integrationType]);

    return (
        <FilterDropdown
            label={translate('origin')}
            items={selectableThirdPartyOrigin}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
        />
    );
}
